import { render, staticRenderFns } from "./QuotationArticleSummaryTable.vue?vue&type=template&id=37977259"
import script from "./QuotationArticleSummaryTable.vue?vue&type=script&lang=ts"
export * from "./QuotationArticleSummaryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports